import axios from "axios";
import { notifyPermissionDenied } from "../components/PermissionFeedback";

let installed = false;

const ACTION_BY_METHOD = {
  post: "create",
  put: "edit",
  patch: "edit",
  delete: "delete",
};

export default function installPermissionFeedback() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 403) {
        const method = String(error.config?.method || "").toLowerCase();
        const action = ACTION_BY_METHOD[method];
        const fallback = action
          ? `You don't have permission to ${action} this item.`
          : "You don't have permission to access this item.";
        const serverMessage = error.response?.data?.message;
        const message =
          serverMessage && !/^(not authorized|forbidden)$/i.test(serverMessage)
            ? serverMessage
            : fallback;
        notifyPermissionDenied(message);
      }

      return Promise.reject(error);
    },
  );
}
